import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";

import {fetchModules, selectModule} from './reducer';
import ModuleSelector from "../../components/ModuleSelector";
import AssignmentPanel from "./AssignmentPanel";

const ModuleAdminManager = (props) => {

    const {modules, selectedModule}  = useSelector(state => state.moduleAdmin.toJS());

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchModules());
    }, []);

    const renderAssignmentPanel = () => {
        if(!selectedModule || selectedModule === '') {
            return;
        }

        return (<AssignmentPanel />);
    }

    return (
        <div className="animated fadeIn">
            <div className="card">
                <div className="card-body">
                    <h4 className="card-title">Modul verwalten</h4>
                    <ModuleSelector modules={modules}
                                    selectedModule={selectedModule}
                                    selectModule={(moduleName) => dispatch(selectModule(moduleName))}/>
                    <div className="row">
                        <div className="col-lg-12">
                            <hr style={{borderTop: '2px solid #c2cfd6'}}/>
                        </div>
                    </div>
                    {renderAssignmentPanel()}
                </div>
            </div>
        </div>
    );
};

export default ModuleAdminManager;


// WEBPACK FOOTER //
// ./src/admin/module/admin/ModuleAdminManager.js